import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { TrainingCourseState } from 'app/_models/training/training-course-state';
import { NotificationService } from 'app/_services/notification.service';
import { SiteService } from 'app/_services/site.service';
import { TrainingService } from 'app/_services/training.service';
import { environment } from 'environments/environment';
import { SortEvent } from 'primeng/api';

@Component({
  selector: 'app-worker-sites',
  templateUrl: './worker-sites.component.html'
})
export class WorkerSitesComponent implements OnInit {

  sites: any[] = [];
  selectedSite: any;

  routeRole: any;

  // pagination
  pageSizes: any = environment.pageSizes;
  pagination: any;
  @ViewChild('paginator', { static: true }) paginator;

  // Sorting: server-side, so the table only ever holds the current page
  public defaultSortField = 'site.name';
  public defaultSortOrder = 1;
  private sortOrderToText = (sortOrder: number) => {
    return sortOrder === 1 ? 'asc' : 'desc';
  };
  public selectedSort = [this.defaultSortField + ',' + this.sortOrderToText(this.defaultSortOrder)];

  public TrainingCourseStateType = TrainingCourseState; // allow enum in template
  public workerUserId: any;

  constructor(
    private siteService: SiteService,
    private trainingService: TrainingService,
    private notificationService: NotificationService,
    private router: Router,
    private globals: Globals,
  ) {
    this.routeRole = globals.user.routeRole;
    this.workerUserId = globals.user.workerUserId;
    this.resetPagination();
  }

  ngOnInit() {
    this.getAllSites(this.pagination);
  }

  // Get all sites
  public getAllSites(pagination) {
    this.siteService.getAllSitesForWorker(pagination, false, this.selectedSort).subscribe((data: any) => {
      this.sites = Array.isArray(data.body) ? data.body : [];
      this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
    });
  }

  public takeInduction(course: any) {
    const body = {
      courseId: course.id,
      workerUserId: this.workerUserId,
    };

    this.trainingService.createNewTrainingCourseForWorker(body).subscribe(result => {
      this.router.navigate([this.routeRole, 'training', result.id]);
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error', 'Could not start the course');
    });
  }

  // Handle Pagination
  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.getAllSites(this.pagination);
  }

  public resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0
    }
  }

  // Handle Sorting
  public customSort(sort: SortEvent) {
    const sortDirection = this.sortOrderToText(sort.order);

    this.selectedSort = [sort.field + ',' + sortDirection];

    if (sort.field === 'siteOwner') {
      this.selectedSort = [
        'site.siteOwnerUser.skylarkUser.user.firstName,' + sortDirection,
        'site.siteOwnerUser.skylarkUser.user.lastName,' + sortDirection,
        'site.name,' + sortDirection,
      ];
    }

    this.goToFirstPage();
    this.getAllSites(this.pagination);
  }

  private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }
}
